import React from 'react'
import MaterialTable from "material-table";

import { getTrans as t } from "../../Localization/translations";

function Checkmt() {
  return (
    <div className='pt-4 container'>
      <MaterialTable
                                            title="Basic Search Preview"
                                                columns={[
                                                    {
                                                        title: `${t('Party Name')}`,
                                                        field: "customer_name",
                                                        headerStyle: {
                                                            verticalAlign: "inherit",
                                                            fontWeight: "bold",
                                                            textAlign: "left"
                                                        },
                                                        cellStyle: {
                                                            textAlign: "left",
                                                            fontSize: 12
                                                        },
                                                    },
                                                    {
                                                        title: `${t("Party Type")}`,
                                                        field: "party_type",
                                                        headerStyle: {
                                                            verticalAlign: "inherit",
                                                            fontWeight: "bold",
                                                            textAlign: "left"
                                                        },
                                                        cellStyle: {
                                                            textAlign: "left",
                                                            fontSize: 12
                                                        },
                                                    },
                                                    {
                                                        title: `${t("Entity Type")}`,
                                                        field: "customer_type",
                                                        headerStyle: {
                                                            verticalAlign: "inherit",
                                                            fontWeight: "bold",
                                                            textAlign: "left"
                                                        },
                                                        cellStyle: {
                                                            textAlign: "left",
                                                            fontSize: 12
                                                        }
                                                    },

                                                ]}
                                                localization={{
                                                    toolbar: {
                                                        searchPlaceholder: "Search Party"
                                                    }
                                                }}

                                                options={{
                                                    sorting: true,
                                                    showTitle: true,
                                                    search: true,
                                                    toolbar: false,
                                                    paging: true,
                                                    pageSize: 10,       // make initial page size
                                                    emptyRowsWhenPaging: false,   // To avoid of having empty rows
                                                    pageSizeOptions: [10, 20, 25, 50],
                                                    paginationType: "stepped",
                                                    showFirstLastPageButtons: false,
                                                    exportAllData: true,
                                                    exportButton: false,
                                                    exportFileName: "Parties",
                                                    actionsColumnIndex: -1,
                                                    isLoading: true,
                                                }}
                                            />
    </div>
  )
}

export default Checkmt
